import common from './components/common';
import productCards from './blocks/product-cards';
import partsCatalog from './blocks/parts-catalogs';
import searchAspProducts from './blocks/search-asp-products';

(function() {
    common();
    productCards();
    partsCatalog();
    searchAspProducts();
})();
